import { Checkbox, styled } from "@mui/material";

const GvCheckboxCustom = styled(Checkbox)(({ theme }) => ({
  "& .MuiSvgIcon-root": {
    fontSize: "1.25rem", // 20px converted to rem
    marginLeft: "-0.55rem",
  },
  "&.MuiCheckbox-root.Mui-checked .MuiSvgIcon-root": {
    fill: theme.palette.primary.main,
  },
  "&.MuiCheckbox-root.MuiCheckbox-colorError": {
    color: theme.palette.error.main,
  },
  "&.MuiCheckbox-root.Mui-disabled": {
    opacity: 0.3,

  },
}));

export default GvCheckboxCustom;
